<template>
  <BModal hide-header hide-footer no-close-on-backdrop size="xl" body-class="rounded-lg p-lg-5 bg-white" :visible="visible" @hide="close">
    <div class="position-relative d-flex">
      <img class="zip d-none d-lg-block" src="/img/temp-dash/zip/temp-dash-zip-1.png" />
      <img
        class="d-block mx-auto mb-3"
        style="width: 232px"
        :src="industry == 'cannabis' ? '/img/logos/apex-logo.png' : '/img/logos/bushel-logo.png'"
        :alt="industry == 'cannabis' ? 'Apex Logo' : 'Bushel44 Logo'"
      />
    </div>
    <div class="border shadow rounded p-3 p-md-5">
      <div class="row mb-3 pb-3 border-bottom">
        <div class="col-12 col-lg-8">
          <div class="row">
            <BushelTextInput v-model="formData.name" label-active="Location Name" :error="submitted && !formData.name" class="col-12 col-lg-6" />
            <BushelSelect
              v-model="formData.operation_type"
              no-deselect
              label="name"
              class="col-12 col-lg-6"
              label-active="Location Type"
              :options="operationTypes"
              :error="submitted && !formData.operation_type"
              :loading="!operationTypes.length"
              @select="(selected) => (formData.operation_type = selected)"
            />
            <BushelTextArea v-model="formData.summary" :rows="3" thin class="col-12" label-active="About Us" />
          </div>
        </div>
        <div class="col-12 col-lg-4">
          <ConstrainImageCropperNoPreview
            class="rounded w-100"
            doc-label="Logo"
            input-id="logo"
            :file-url="currentCompany && !currentCompany.logoLink.includes('gravatar') ? currentCompany.logoLink : ''"
            no-overlay
            cropping-height="150px"
            display-height="150px"
            @file-added="(file) => (companyLogo = file)"
          />
        </div>
      </div>
      <div class="row">
        <BushelTextInput v-model="formData.line1" :error="submitted && !formData.line1" label-active="Address Line 1" class="col-12 col-lg-6" />
        <BushelTextInput v-model="formData.line2" label-active="Address Line 2" class="col-12 col-lg-6" />
      </div>
      <div class="row pb-3 mb-3 border-bottom">
        <BushelTextInput v-model="formData.city" :error="submitted && !formData.city" label-active="City" class="col-12 col-lg-3" />
        <BushelSelect
          :value="formData.country"
          class="col-12 col-lg-3"
          label="text"
          label-active="Country"
          :error="submitted && !formData.country"
          no-deselect
          :loading="countriesLoading"
          :options="countries"
          @select="
            (selected) => {
              formData.country = selected;
              fetchStates(selected.id);
            }
          "
        />
        <BushelSelect
          :value="formData.state"
          class="col-12 col-lg-3"
          label="text"
          label-active="State"
          :error="submitted && !formData.state"
          no-deselect
          :loading="statesLoading"
          :options="states"
          @select="(selected) => (formData.state = selected)"
        />
        <BushelTextInput v-model="formData.zip" :error="submitted && !formData.zip" label-active="Zip" class="col-12 col-lg-3" />
      </div>
      <div class="row">
        <div class="col-12 col-lg-6">
          <BushelTextInput
            v-model="formData.state_license"
            class="mb-3"
            :error="submitted && !formData.state_license"
            :label-active="industry == 'cannabis' ? 'State License Number' : 'State License Number (optional)'"
          />
          <SingleFileUploader
            id="state-license-uploader"
            input-id="stateLicenseDoc"
            class="d-block d-lg-none"
            :file-url="formData.state_license_doc"
            no-overlay
            :allow-delete="true"
            download-path="buyers/state-license-doc/download"
            :doc-label="'State License Supporting Document'"
            @create-document="formData.state_license_doc = $event"
            @delete-document="formData.state_license_doc = undefined"
          />
          <BushelBtn class="btn-block" variant="success" :disabled="creating" @click="submit">
            <div v-if="creating" class="spinner-border spinner-border-sm" role="status">
              <span class="sr-only">Loading...</span>
            </div>
            Finish
          </BushelBtn>
        </div>
        <SingleFileUploader
          id="state-license-uploader"
          input-id="stateLicenseDoc"
          class="d-none d-lg-block col-6"
          :file-url="formData.state_license_doc"
          no-overlay
          :allow-delete="true"
          download-path="buyers/state-license-doc/download"
          :doc-label="'State License Supporting Document'"
          @create-document="formData.state_license_doc = $event"
          @delete-document="formData.state_license_doc = undefined"
        />
      </div>
    </div>
  </BModal>
</template>
<script>
import { mapState, mapActions } from "vuex";
import ConstrainImageCropperNoPreview from "@/components/common/ConstrainImageCropperNoPreview.vue";
import SingleFileUploader from "@/components/documents/SingleFileUploader.vue";
import * as api from "@/services/api";

export default {
  components: {
    ConstrainImageCropperNoPreview,
    SingleFileUploader,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    currentCompany: {
      type: Object,
      default: () => {},
    },
  },
  emits: ["operationCreated", "hide"],
  data() {
    return {
      companyLogo: null,
      industry: "cannabis",
      states: [],
      statesLoading: false,
      countries: [],
      countriesLoading: false,
      submitted: false,
      error: false,
      creating: false,
      formData: {
        name: this.currentCompany ? this.currentCompany.name : "",
        operation_type: null,
        summary: "",
        line1: "",
        line2: "",
        city: "",
        state: "",
        country: "",
        zip: "",
        state_license: "",
        state_license_doc: "",
      },
    };
  },
  computed: {
    ...mapState("base", {
      operationTypes: (state) => state.operationTypes,
    }),
  },
  mounted() {
    this.fetchOperationTypes();
    this.fetchAllCountries();
    if (this.currentCompany) {
      this.fetchStates(this.currentCompany.country_id);
    }
  },
  methods: {
    ...mapActions({
      createOperation: "operations/createOperation",
      fetchOperationTypes: "base/fetchOperationTypes",
    }),
    close() {
      this.$emit("hide", true);
    },
    fetchAllCountries() {
      this.countriesLoading = true;
      api.get("countries").then((response) => {
        this.countriesLoading = false;
        this.countries = response.data;
        if (this.currentCompany) {
          this.formData.country = this.countries.find((country) => country.id === this.currentCompany.country_id);
        }
      });
    },
    fetchStates(countryId) {
      this.statesLoading = true;
      return api.get(`states/by-country/${countryId}`).then((response) => {
        this.statesLoading = false;
        this.states = response.data;
        if (this.currentCompany) {
          this.formData.state = this.states.find((state) => state.id === this.currentCompany.state_id);
        }
      });
    },
    submit() {
      this.submitted = true;
      this.creating = true;
      if (
        this.formData.name &&
        this.formData.operation_type &&
        this.formData.line1 &&
        this.formData.city &&
        this.formData.state &&
        this.formData.country &&
        this.formData.zip &&
        this.formData.state_license
      ) {
        this.submitted = false;
        const payload = {
          company_id: this.currentCompany.id,
          name: this.formData.name,
          operation_type_id: this.formData.operation_type.id,
          summary: this.formData.summary,
          line_one: this.formData.line1,
          line_two: this.formData.line2,
          city: this.formData.city,
          state_id: this.formData.state.id,
          country_id: this.formData.country.id,
          zip: this.formData.zip,
          state_license: this.formData.state_license,
          state_license_doc: this.formData.state_license_doc,
          logo: this.companyLogo,
        };
        this.createOperation(payload).then(
          (response) => {
            this.$emit("operationCreated", response.data);
            this.creating = false;
          },
          (error) => {
            this.error = true;
            this.creating = false;
          },
        );
      } else {
        this.creating = false;
      }
    },
  },
};
</script>
<style>
.zip {
  position: absolute;
  bottom: 0;
  right: 20px;
  z-index: 100;
}
</style>
